import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createDocumentType, updateDocumentType, deleteDocumentType } from '../../../../api/administration/edmsSettings/documentTypes';

export const useDocumentTypeMutations = (queryKey = ['documentTypes']) => {
  const queryClient = useQueryClient();

  const invalidateDocumentTypes = async () => {
    await queryClient.invalidateQueries({ queryKey, exact: false });
    await queryClient.invalidateQueries({ queryKey: ['documentTypes', 'active'], exact: false });
  };

  const createMutation = useMutation({
    mutationFn: createDocumentType,
    onSuccess: () => invalidateDocumentTypes(),
  });

  const updateMutation = useMutation({
    mutationFn: updateDocumentType,
    onSuccess: () => invalidateDocumentTypes(),
  });

  const deleteMutation = useMutation({
    mutationFn: deleteDocumentType,
    onSuccess: () => invalidateDocumentTypes(),
  });

  return {
    createMutation,
    updateMutation,
    deleteMutation,
  };
};

export default useDocumentTypeMutations;
